import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, authFeatureKey } from '../reducers/auth.reducer';

const selectAuthState = createFeatureSelector<State>(authFeatureKey);

export const getSignedInUser = createSelector(selectAuthState, state => state.signedInUser);
export const getSignInResult = createSelector(selectAuthState, state => state.signInResult);
export const getUpdateSignedInUserIsTermsAgreeResult = createSelector(selectAuthState, state => state.updateSignedInUserIsTermsAgreeResult);
